export const hasOnlyUniqueVals = (arr: string[]) => {
  const loweredStringsArr = arr.map((str) => str.toLocaleLowerCase());
  return !loweredStringsArr.some(function (item) {
    return loweredStringsArr.indexOf(item) !== loweredStringsArr.lastIndexOf(item);
  });
};
